import React from 'react';
import './style.scss'
import Menu from '../../components/Menu'
import Footer from '../../components/Footer'
import ImgNews1 from '../../assets/imagens/img-news1.jpg'
import ImgNews2 from '../../assets/imagens/img-news2.jpg'
import ImgNews3 from '../../assets/imagens/img-news3.jpg'

import { Link } from 'react-router-dom'


function Insights() {
  return (
    <>
      <Menu></Menu>

      <section className="insights02 container">

        <Link to="/insights/news" className="insights02__card02">
          <div className="img-insights02">
            <img src={ImgNews1} alt="" />
          </div>
          <div className="text-insights02">
            <h4>E-commerce tem primeiro recuo durante a pandemia</h4>
            <p>Produtos de giro rápido (FMCG) se mantém estáveis na semana</p>
          </div>
        </Link>

      </section>



      {/* PRIMEIRA LISTA DE NOTÍCIAS */}
      <div className="insights-blog container">

        <Link to="/insights/news" className="insights-blog__news primary-news">
          <img src={ImgNews1} alt="" />
          <div className="insights-blog__news__title">
            <h4>E-commerce tem primeiro recuo durante a pandemia</h4>
            <p>Produtos de giro rápido (FMCG) se mantém estáveis na semana</p>
          </div>
        </Link>

        <Link to="/insights/news" className="insights-blog__news secondary-news">
          <img src={ImgNews2} alt="" />
          <div className="insights-blog__news__title">
            <h4>E-commerce tem primeiro recuo durante a pandemia</h4>
            <p>Produtos de giro rápido (FMCG) se mantém estáveis na semana</p>
          </div>
        </Link>

        <Link to="/insights/news" className="insights-blog__news tertiary-news">
          <img src={ImgNews3} alt="" />
          <div className="insights-blog__news__title">
            <h4>E-commerce tem primeiro recuo durante a pandemia</h4>
            <p>Produtos de giro rápido (FMCG) se mantém estáveis na semana</p>
          </div>
        </Link>

      </div>


      {/* SEGUNDA LISTA DE NOTÍCIAS */}
      <div className="insights-blog2 container">
        <div className="insights-blog2__news news1">
          <div className="insights-blog2__news__title2">
            <img src={ImgNews1} alt="" />
            <div className="insights-blog2__news__title2__text-info">
              <span>#COVID-19</span>
              <h4>Lorem Ipsum</h4>
              <p>Is simply dummy text of the printing and typesetting industry.</p>
              {/* <p><i> - 10/10/1010</i></p> */}
              <time class="updated knockout h5"> 01-01-2020</time>
            </div>
          </div>
        </div>
        <hr></hr>
        <div className="insights-blog2__news news2">
          <div className="insights-blog2__news__title2">
            <img src={ImgNews2} alt="" />
            <div className="insights-blog2__news__title2__text-info">
              <small>InfoClass</small>
              <h4>Lorem Ipsum</h4>
              <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. </p>
              {/* <p><i> - 10/10/1010</i></p> */}
              <time class="updated knockout h5"> 01-01-2020</time>
            </div>
          </div>
        </div>
        <hr></hr>
        <div className="insights-blog2__news news3">
          <div className="insights-blog2__news__title2">
            <img src={ImgNews3} alt="" />
            <div className="insights-blog2__news__title2__text-info">
              <small>InfoClass</small>
              <h4>Lorem Ipsum</h4>
              <p>Is simply dummy text of the printing and typesetting industry, simply dummy text of the printing and typesetting industry.</p>
              {/* <p><i> - 10/10/1010</i></p> */}
              <time class="updated knockout h5"> 01-01-2020</time>
            </div>
          </div>
        </div>

      </div>
      <Footer></Footer>
    </>
  );
}

export default Insights;